import React from "react";
import { Button } from "./Button";
import { Link } from 'react-router-dom';
import './VideoSection.css';

function VideoSection() {
  return (
    <div className="video-container"> 
      <video src="/videos/vid.mp4" autoPlay loop muted/>
      <h1>Woof: Give a Dog a Home</h1>
      <p>Helping pets find their forever home has never been easier.</p>
      <Link to='/signup' className='btn-link'>
        <Button
          className='video-btns'
          buttonSize='btn--large'
          buttonStyle='btn--other'>
          SIGN UP TODAY
        </Button>
      </Link>
    </div>
  )
}

export default VideoSection